module.exports = __webpack_public_path__ + "img/noDataMarginDark.3bb1ece7.png";